module.exports = __webpack_public_path__ + "img/lunch_available.079a38be.png";